import React from "react";

export const splitLines = (block = "") =>
  String(block || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

export const stripBullet = (line = "") =>
  String(line || "").replace(/^[-*\u2022\d.\s]+/, "").trim();

export const splitSentences = (text = "") => {
  const raw = String(text || "").trim();
  if (!raw) return [];
  const matches = raw.match(/[^.!?]+[.!?]+|[^.!?]+$/g);
  return (matches || []).map((s) => s.trim()).filter(Boolean);
};

export const renderParagraphs = (content, styles) => {
  const lines = splitLines(content || "");
  if (!lines.length) return null;

  const blocks = [];
  let listItems = [];

  const flushList = () => {
    if (!listItems.length) return;
    blocks.push(
      <ul className={styles.list} key={`list-${blocks.length}`}>
        {listItems.map((item, idx) => (
          <li key={`${item}-${idx}`}>{item}</li>
        ))}
      </ul>
    );
    listItems = [];
  };

  lines.forEach((line, idx) => {
    if (/^[-*\u2022]/.test(line)) {
      listItems.push(stripBullet(line));
      return;
    }
    flushList();
    blocks.push(
      <p className={styles.paragraph} key={`p-${idx}`}>
        {line}
      </p>
    );
  });

  flushList();
  return blocks;
};

export const clamp = (value, min = 0, max = 100) =>
  Math.min(max, Math.max(min, value));
